import React from 'react';
import { Link } from 'react-router-dom';
import './News.css';
import './NewsArchive.css';
import useNews from '../../hooks/useNews';
import Footer from '../Footer';

/* Every published post, newest first, as a grid — the News page's carousel
   shows three at a time and is slow to page through, so this is where the
   "Other News" heading now leads. Reuses the News page's card styles. */
function NewsArchive() {
  const { news, loading, error } = useNews();

  return (
    <>
      <div className="news-page-news">
        <header className="page-hero page-hero--plain">
          <div className="page-hero__inner">
            <p className="page-hero__eyebrow">News</p>
            <h1 className="page-hero__title">All News</h1>
            {!loading && !error && (
              <p className="page-hero__lede">{news.length} {news.length === 1 ? 'post' : 'posts'}</p>
            )}
          </div>
        </header>

        <div className="news-archive page-body">
          <Link to="/News" className="back-button news-archive__back">
            ← Back to News
          </Link>

          {loading && (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Loading news...</p>
            </div>
          )}

          {error && (
            <div className="error-container">
              <p>Failed to load news: {error.message}</p>
            </div>
          )}

          {!loading && !error && (
            <div className="news-archive__grid">
              {news.map((article) => (
                <Link
                  to={article.link}
                  className="news-card-link-news"
                  key={article.id}
                >
                  <div className="news-card-news">
                    <div className="news-card-image-news">
                      <img src={article.image} alt={article.title} loading="lazy" />
                    </div>
                    <div className="news-card-content-news">
                      <p className="news-card-date-news">{article.date}</p>
                      <h3 className="news-card-title-news">{article.title}</h3>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NewsArchive;
